import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { localizeDateObj, hasProductTerminology } from 'utils/helpers'
import {
  WalletIcon,
  ReachIcon,
  PriceSensitivityIcon,
  EventIcon,
  ItemsIcon
} from 'images'
import { SecondaryButton } from 'components/Shared/Button'

export const useCustomSegmentationInfo = ({ state, setCustomerModalOpen }) => {
  const { t } = useTranslation()
  const currency = useMemo(() => localStorage.getItem('userCurrency') || 'EUR', [])

  function getInfo(state) {
    const info = []

    if (state.excludedPurchaseDate.value) {
      info.push({
        title: t('PackageBuilder.customerSegmentation.purchaseDateExclusion'),
        value: `${t(`PackageBuilder.customerSegmentation.${state.excludedPurchaseDate.qualifier}`)} ${localizeDateObj(state.excludedPurchaseDate.value, 'de')}`,
        icon: <WalletIcon width={22} height={22}/>,
      })
    }

    if (state.excludedPriceRange.value) {
      info.push({
        title: t('PackageBuilder.customerSegmentation.priceSensitivityExclusion'),
        value: `${t(`PackageBuilder.customerSegmentation.${state.excludedPriceRange.qualifier}`)} ${state.excludedPriceRange.value} ${currency}`,
        icon: <PriceSensitivityIcon width={22} height={22}/>,
      })
    }
    
    if (state.customerIds.value.length > 0) {
      info.push({
        title: t('PackageBuilder.customerSegmentation.customerListTitle'),
        value:           
        <SecondaryButton
          text={state.customerIds.qualifier === 'exclude' ? t('PackageBuilder.customerSegmentation.excludedCustomerIdsTitle') : t('PackageBuilder.customerSegmentation.includedCustomerIdsTitle')}
          color="navy"
          size="small"
          fullWidth={false}
          type="button"
          disabled={!state.customerIds.qualifier}
          onClick={(e) => {
            e.preventDefault()
            setCustomerModalOpen(true)
          }}
        />,
        icon: <ReachIcon width={22} height={22}/>,
      })
    }


    if (state.excludedTicketCategories.length > 0) {
      info.push({
        title: t('PackageBuilder.customerSegmentation.ticketCategoryExclusion'),
        value: state.excludedTicketCategories.map((x) => t(`Event.ticketType.${x}`)).join(', '),
        // ticket-stub glyph only for accounts speaking the event language
        icon: hasProductTerminology() ? <ItemsIcon width={22} height={22}/> : <EventIcon width={22} height={22}/>,
      })
    }

    return info
  }
  return {
    customSegmentationInfo: getInfo(state),
  }
}